<template>
  <div class="position-relative">
    <FloatLabel :class="`${selectDisabled ? 'float-label' : ''}`" :label="label" :optional="optional" :ask="ask" :tooltip="tooltip">
      <select
        class="shadow-none form-control select-custom"
        v-model="val"
        v-on:change="handleChange"
        :disabled="selectDisabled || false"
        :class="[`${error ? 'invalid' : ''} ${selectDisabled ? 'disabled' : ''} ${this.selectValue !== '' ? '' : 'gray'}`]"
        v-if="isObjectOptions"
      >
      <option value="" :disabled="label !== 'Model year'">{{ this.options.length === 0 ? 'N/A' : 'Select one'}}</option>
        <option
          v-for="(e, idx) in options" :key="idx" :value="e.value"
        >{{ e.key }}</option>
      </select>
      <select
        class="shadow-none form-control select-custom"
        v-model="val"
        v-on:change="handleChange"
        :disabled="selectDisabled || false"
        :class="[`${error ? 'invalid' : ''} ${selectDisabled ? 'disabled' : ''} ${this.selectValue !== '' ? '' : 'gray'}`]"
        v-else
      >
        <option value="" :disabled="label">{{ this.options.length === 0 ? 'N/A' : 'Select one'}}</option>
        <option v-for="(e, idx) in options" :key="idx" :value="label === 'Colour' ? e.toUpperCase() : e">{{ e }}</option>
      </select>
    </FloatLabel>
    <div class="fs-12 text-right mb-2 mt-n3 pr-2 err-text">{{ error ? helperText : '' }}</div>
    <img
      v-if="shouldShowSpinner"
      class="input-spinner"
      src="../../assets/images/input-spinner.gif"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: { 
    FloatLabel: () => import('./FloatLabel.vue')
  },
  name: 'CustomSelect',
  inheritAttrs: false,
  model: {
    prop: 'selectValue',
    event: 'change'
  },
  props: {
    selectValue: {
      type: [Number, String],
      default: () => ""
    },
    options: {
      type: Array,
      default: () => [],
    },
    label: String,
    name: {
      type: String,
      default: () => ""
    },
    isNa: {
      type: Boolean,
      default: false,
    },
    ask: {
      type: Boolean,
      default: () => false
    },
    tooltip: {
      type: String,
      default: () => ""
    },
    error: Boolean,
    helperText: String,
    isFocus: Boolean,
    optional: Boolean,
    selectDisabled: Boolean,
  },
  computed: {
    ...mapState({
      isLoadingAG: (state) => state.info.isLoadingAG,
      currentAPIParams: (state) => state.info.currentAPIParams,
      isAGSource: (state) => state.common.isAGSource,
    }),
    val: {
      get: function() {
        return this.selectValue;
      },
      set: function() {},
    },
    isNaCondition: function() {
      return this.options.length === 0 && this.isNa
    },
    isObjectOptions: function() {
      const bypassList = ['Sub model'];
      return bypassList.includes(this.label);
    },
    shouldShowSpinner() {
      // Only show spinner for model_year field
      if (this.name !== 'model_year') {
        return false;
      }
      
      // Only show spinner for fields not in current API params
      const fieldName = this.name;
      const isFieldNotInParams = !this.currentAPIParams || !Object.prototype.hasOwnProperty.call(this.currentAPIParams, fieldName);
      const agCondition = this.isAGSource && this.isLoadingAG && isFieldNotInParams;
      
      return agCondition;
    },
  },
  methods: {
    handleChange: function (e) {
      this.$emit('change', e.target.value)
      this.$emit('setNextInput')
      e.target.blur()
    },
    convertShiftValue: function (e) {
      if(e === 'AT') {
        return 'Automatic'
      } else {
        return 'Manual'
      }
    },
  }
}
</script>
<style lang="scss">
select.form-control.invalid, input.form-control.invalid {
  border-color: red !important ;
}
select.form-control.disabled {
  border: none;
}
.float-label > span{
  z-index: 0;
  background-color: transparent;
  &::after {
    background: none;
  }
}
.err-text {
  color: red;
  font-style: italic;
  min-height: 16px;
}
.border-lable-flt {
  margin-bottom: 0;
}
.non-foucus {
  border-color: #ced4da !important;
}
.next-select-input {
  color: #383C3F;
  background-color: #fff;
  border-color: #00BB65 !important;
  outline: 0;
}
.select-custom {
  &.gray {
    color: #989898 !important;
  }
  
  option {
    color: #383c3f !important;

    &:first-child {
      color: #989898 !important;
    }
  }
}
.input-spinner {
  position: absolute;
  top: 50%;
  right: 35px;
  transform: translateY(-85%);
  width: 24px;
}
@media screen and(min-width: 768px) {
  .input-spinner {
    right: 45px !important;
  }
}
</style>